module.exports = __webpack_public_path__ + "static/media/home-iconic.fea098c1.jpg";